import {getTextByValue} from "../../../../Utilities/Types/listUtilities";
import {OWN_LOAN_STATUS_LIST} from "./ownLoanConstants";
import {updateOwnLoanItemModel} from "./ownLoanFactory";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import type { OwnLoanItem } from './ownLoan.types';

export const getLoanOwnStatusTextByValue = (value: string | number = "") => getTextByValue(OWN_LOAN_STATUS_LIST, value);

export async function copyToClipboard(textToCopy: string) {
    if (!navigator.clipboard) {
        alert("Copy not supported. Try again.");
        return;
    }
    try {
        await navigator.clipboard.writeText(textToCopy);
        setTimeout(() => alert("Address copied to clipboard."), 1000);
    } catch (err) {
        alert("Copy failed. Try again.");
    }
}


export function getChangedOwnLoanItemsForUpdate(ownLoanItems: OwnLoanItem[], originalOwnLoanItems: OwnLoanItem[]) {
    return ownLoanItems
        .filter((item: OwnLoanItem) => {
            const originalOwnLoanItem = originalOwnLoanItems.find((o: OwnLoanItem) => o.ownLoanItemId === item.ownLoanItemId);

            if (!originalOwnLoanItem) return false;

            const statusChanged = originalOwnLoanItem.ownLoanStatus !== item.ownLoanStatus;
            const notesChanged = (originalOwnLoanItem.ownLoanNotes || "") !== (item.ownLoanNotes || "");

            return statusChanged || notesChanged;
        })
        .map((item: OwnLoanItem) => updateOwnLoanItemModel({
            ownLoanItemId: item.ownLoanItemId,
            ownLoanStatus: item.ownLoanStatus,
            ownLoanNotes: item.ownLoanNotes,
        }));
}

export function convertToCurrencyFormat(value: string | number) {
    if (isNaN(Number(value)) || isNullOrUndefined(value)) {
        return "";
    }
    return `$ ${parseFloat(String(value)).toFixed(2)}`;
}
